import { useMemo } from "react";
import useSelectedUserPoaForLoggedInUser from "../useSelectedUserPoaForLoggedInUser";
import { IPortfolio } from "@portal/types/api/IPortfolio";
import usePortfolios from "../usePortfolios";
import { IUseFilteredPortfolios } from "./types";
import { IPoaInfo, PowerOfAttorneyType } from "@portal/types/api/IPoaInfo";

const hasFullPoaAccess = (portfolio: IPortfolio, poa: IPoaInfo[] | undefined, selectedUserId: string | undefined) => {
  const poaObject = poa?.find(p => p.customerNumber === selectedUserId);
  const portfolioWithPoa = poaObject?.portfolios.find(po => po.portfolioId === portfolio.portfolioId);
  return (
    portfolioWithPoa &&
    (portfolioWithPoa.powerOfAttorneyType === PowerOfAttorneyType.Full ||
      portfolioWithPoa.powerOfAttorneyType === PowerOfAttorneyType.Child)
  );
};

const useFilteredPortfolios: IUseFilteredPortfolios = ({
  showPortfoliosForAllCenterIds,
  hidePortfoliosWithOnlyReadAccess,
  onlyAsk,
  ignoreIps,
  checkForClientAccount,
}) => {
  const { isLoading, bankPortfolios, data: portfolios } = usePortfolios();
  const portfolioList = showPortfoliosForAllCenterIds ? portfolios : bankPortfolios;

  const { data: poa, selectedUser } = useSelectedUserPoaForLoggedInUser();

  const filteredPortfolios = useMemo(
    () =>
      portfolioList?.filter(
        p =>
          (ignoreIps ? p.taxationType !== "IPS" : true) &&
          (!checkForClientAccount || p.isClient) &&
          (onlyAsk ? p.taxationType === "ASK" : true) &&
          (!hidePortfoliosWithOnlyReadAccess || !selectedUser?.userId || hasFullPoaAccess(p, poa, selectedUser?.userId)),
      ) ?? [],
    [checkForClientAccount, hidePortfoliosWithOnlyReadAccess, ignoreIps, onlyAsk, poa, portfolioList, selectedUser?.userId],
  );

  return { data: filteredPortfolios, isLoading, error: undefined };
};

export default useFilteredPortfolios;
